import React, { ReactNode, useContext, useEffect, useState } from 'react';

import SalesOrderDetailContext from '@totem/components/salesOrders/details/SalesOrderDetailContext';
import { SalesOrderHeader } from '@totem/components/salesOrders/details/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { SALES_ORDER_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  salesOrderNumber: string;
  children?: ReactNode;
};

const SalesOrderDetailContainer = ({ salesOrderNumber, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [header, setHeader] = useState<SalesOrderHeader | null>(null);

  useEffect(() => {
    if (!salesOrderNumber) {
      return;
    }

    setLoading(true);

    fetch(
      `${SALES_ORDER_ENDPOINT}/${encodeURIComponent(salesOrderNumber)}/header`,
      {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      },
    )
      .then((res) => res.json())
      .then((result: SalesOrderHeader) => {
        setHeader(result ?? null);
      })
      .then(() => setLoading(false));
  }, [salesOrderNumber, getApiToken]);

  return (
    <SalesOrderDetailContext.Provider value={{ loading, header }}>
      {children}
    </SalesOrderDetailContext.Provider>
  );
};

export default SalesOrderDetailContainer;
